import { FC, ReactNode } from "react";
import { sharedProps } from "~/constants";
import { ExternalLink } from "../ExternalLink";
import { InternalLink } from "../InternalLink";
import { LinkDivider } from "./LinkDivider";

interface Props {
  children: ReactNode;
  isExternalLink?: boolean;
  isLast?: boolean;
  onClick: () => void;
  to: string;
}

export const FooterLink: FC<Props> = ({
  children,
  onClick,
  to,
  isLast,
  isExternalLink,
}) => {
  const Link = isExternalLink ? ExternalLink : InternalLink;

  return (
    <>
      <Link
        color="fg-on-accent"
        onClick={onClick}
        py={{ base: 3, md: "initial" }}
        size="md"
        to={to}
        {...sharedProps.link.hover}
      >
        {children}
      </Link>
      {!isLast && LinkDivider}
    </>
  );
};
